/**
 * App script
 */
import LCASAdmin from '@scripts/controllers/Admin';
import LCASFront from '@scripts/controllers/Front';

document.addEventListener('DOMContentLoaded', () => {
  if (window.licornAlertsub !== undefined) {
    let controller = licornAlertsub.admin ? new LCASAdmin() : new LCASFront();
    controller.boot();
  }
});
